/** Client IDs of apps that report instance health to Vertex */
export const INSTANCE_ENABLED_APP_IDS = new Set(['vtak']);
